import React, { Component } from 'react';
import axios from 'axios'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { Button, Divider, Form, Feed, Icon } from 'semantic-ui-react'
import * as moment from 'moment';
import { base, serverIp, getOrderKey, toCurrency, pythonApiIp } from '../../../../config/constants';
import * as UiConsts from '../../../../config/UiConstants.js'
import { Link } from 'react-router-dom';

export class WhatsappGetUsersPendingOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order_num: '',
            totalOrderAmount: '',
            depositAmount: '',
            balance: '',
            phone: this.props.phone,
            loading: false,
            visible: true,
        }
    }

    cleanPhoneFromFirebase = () => {
        console.log("whatx1 clean phone:" + this.props.phone)
        let newPhone = this.props.phone.replace("256", 0)
     //   console.log("whatx12 clean phone:" + newPhone)
        return newPhone
    }

    getUsersPendingOrders = () => {
        console.log("pendx1 ++++++ sendToDepRequested +++")
        if (!this.props.phone) {
            alert("no phone ")
        } else {

            this.setState({ loading: true })

            var d = new Date();
            let now = moment().format('MMMM Do, h:mm:ss a');

            //axios.post(pythonApiIp + 'getUsersPendingOrders', {
            axios.post(serverIp + 'findOrders/getUsersPendingOrders', {
                apiKey: "asdf@asdfasdf",
                phone: this.cleanPhoneFromFirebase(this.props.phone),
            })
                .then((response) => {
                    this.setState({ loading: false })
                    console.log("pendx13:" + JSON.stringify(response.data, null, 3));

                    if (response.data.result && response.data.pendingOrders) {
                        console.log("pendx13: results is true:")

                        let phone = this.props.phone;
                        let messageId = this.props.messageId;

                        // response.data.pendingOrders.forEach(function (element, index) {
                        //  console.log("pendx14 order:" + element.order_num + "::fborderkey:" + element.fborderkey + "::itemType:" + element.itemtype + "::status:" + element.status);

                        let updateString = 'whatsapp/' + phone + '/messages/' + messageId + '/pendingOrders'
                        console.log("pendx15 order:" + updateString)
                        // UDPATE ORDER
                        base.update(updateString, {
                            // data: {uid: userUid},
                            data: response.data.pendingOrders,
                            then(err) {
                                if (!err) {
                                    console.log("pndx165 uupdated message:");
                                }
                            }
                        });

                        // });

                    } else {
                        console.log("pendx14 failed!!")
                        alert(response.data.message)
                    }

                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loading: false })
                });
        }
    }

    render() {

        
        const pendingOrderLoop = this.props.message.pendingOrders && this.props.message.pendingOrders.length > 0
            ? this.props.message.pendingOrders.map((order) =>
                <div>
                    <Feed.Event>
                        <Feed.Content>
                            <Feed.Summary>
                                <Feed.User> <Link to={'/dashboard/singleOrderView/' + order.order_num} target="_blank">{order.order_num} </Link></Feed.User> {order.itemtype}
                                {/* <Feed.Date>{order.dateEntered}</Feed.Date> */}
                            </Feed.Summary>
                            <Feed.Summary>{order.status}</Feed.Summary>
                            <Feed.Summary>Entered: {order.dateEntered}</Feed.Summary>
                      
                            
                        </Feed.Content>
                    </Feed.Event>
                    <Divider />
                </div>
            )
            : ''

        const pendingOrderUI = this.props.message.pendingOrders && this.props.message.pendingOrders.length > 0
            ? <div>
                <Divider horizontal>{'PENDING ORDERS'}</Divider>
                <Feed>
                    {pendingOrderLoop}
                </Feed>
            </div>
            : ''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <Form onSubmit={this.getUsersPendingOrders}>
                    <Button fluid color='pink'> GET PENDING ORDERS</Button>
                </Form>
                {pendingOrderUI}
            </div>
        )
    }
}

export default WhatsappGetUsersPendingOrders;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappGetUsersPendingOrders.js